import { connect } from "react-redux";
import React, {useCallback, useEffect, useMemo, useRef, useState} from "react";

import dayjs from "dayjs";
import * as formatter from "../../../../config/formatter";
import {
    CAlert,
    CButton,
    CCol,
    CForm,
    CFormSelect,
    CInputGroup,
    CInputGroupText,
    CNav,
    CNavItem, CNavLink,
    CRow, CTabContent, CTabPane
} from "@coreui/react";
import StoreListWhere from "../../where/StoreListWhere";
import { DatePicker } from "antd";
import locale from "antd/es/date-picker/locale/ko_KR";
import { Loading } from "../../../../components/common";
import { AgGridReact } from "ag-grid-react";
import { Br, Cut, Line, Printer, render, Row, Text } from "react-thermal-printer";
import * as saleMethod from "../../../../api/method/saleMethod";
import * as o2Api from "../../../../api/api";

import CardApprSaleReport from "./appr/CardApprSaleReport";
import CardCompanyApprSaleReport from "./appr/CardCompanyApprSaleReport";
import CashApprSaleReport from "./appr/CashApprSaleReport";


const CardSaleReport = (props) => {

    const gridRef = useRef();
    const containerStyle = useMemo(() => ({ width: "100%", height: "100%" }), []);

    const [pos, setPos] = useState([{ deviceId: "전체" }]);
    const [currentSaleStatData, setCurrentSaleStatData] = useState([]);
    const [currentSaleData, setCurrentSaleData] = useState([]);
    const [loading, setLoading] = useState(false);
    const [error, setError] = useState({
        visible: false,
        message: ""
    });
    const [activeKey, setActiveKey] = useState(1);
    const [searchForm, setSearchForm] = useState({
        deviceId: "전체",
        saleDt: dayjs()
    });

    useEffect(() => {
        if (props.selected.storeCd.length > 0) {
            // getStoreDevice();
        }
    }, [props.selected.storeCd]);
    

    /*여기부터 화면Grid Start*/
    return (
        <>
            <div style={containerStyle}>
                {error.visible ? <CAlert color="danger" dismissible={true}>{error.message}</CAlert> : null}
                <div className="d-grid gap-1 d-md-flex justify-content-between" style={{ marginBottom: 10 }}>
                    <h5>카드/현금 승인현황</h5>
                </div>
                <CCol>
                    <CNav variant="tabs" role="tablist">
                        <CNavItem>
                            <CNavLink
                                active={activeKey === 1}
                                onClick={() => setActiveKey(1)}>카드승인현황</CNavLink>
                        </CNavItem>
                        <CNavItem>
                            <CNavLink
                                active={activeKey === 2}
                                onClick={() => setActiveKey(2)}>카드(매입사별)승인현황</CNavLink>
                        </CNavItem>
                        <CNavItem>
                            <CNavLink
                                active={activeKey === 3}
                                onClick={() => setActiveKey(3)}>현금영수증 승인현황</CNavLink>
                        </CNavItem>
                    </CNav>
                    <CTabContent>
                        <CTabPane role="tabpanel" aria-labelledby="basic-tab" visible={activeKey === 1}>
                            <div style={{height: 10}}/>
                            <CardApprSaleReport />
                        </CTabPane>
                        <CTabPane role="tabpanel" aria-labelledby="basic-tab" visible={activeKey === 2}>
                            <div style={{height: 10}}/>
                            <CardCompanyApprSaleReport />
                        </CTabPane>
                        <CTabPane role="tabpanel" aria-labelledby="basic-tab" visible={activeKey === 3}>
                            <div style={{height: 10}}/>
                            <CashApprSaleReport />
                        </CTabPane>
                    </CTabContent>
                </CCol>
            </div>
        </>
    ); /*End return화면*/

}

const mapStateToProps = (state) => {
    const { account, store, selected } = state;
    return {
        account, store, selected
    };
};

export default connect(mapStateToProps, null)(CardSaleReport);